import { Badge } from '@nwwp/ui-shadcn/components/badge'
import { cn } from '@nwwp/ui-shadcn/lib/utils'

type ArticleHeaderProps = {
  title: string
  /** e.g. "Part 1 of 6" */
  partLabel?: string
  dateline?: string
  className?: string
}

function ArticleHeader({ title, partLabel, dateline, className }: ArticleHeaderProps) {
  return (
    <header data-slot="article-header" className={cn('flex flex-col gap-3', className)}>
      {partLabel ? (
        <Badge variant="secondary" className="w-fit text-body-xs">
          {partLabel}
        </Badge>
      ) : null}
      <h1 className="text-title-2xl text-balance text-foreground">{title}</h1>
      {dateline ? <p className="text-body-sm text-muted-foreground">{dateline}</p> : null}
    </header>
  )
}

export { ArticleHeader }
export type { ArticleHeaderProps }
